import React from "react";
import {useState, useEffect} from "react";
import defProfile from "../../../../assets/images/anonymous.jpg.webp";
import {showToast} from "../../../../redux/slices/toastSlice";
import {useDispatch} from "react-redux";
import {
    FaArrowLeft,
    FaGift,
    FaCopy,
    FaShareNodes,
    FaUsers,
    FaDollarSign,
    FaLightbulb,
    FaCheck,
} from "react-icons/fa6";
import ProfileService from "../../../../services/Profile";
import fixDate from "../../../../components/DateFormatter/FixDate";
// import { FaUsers } from "react-icons/fa";

const InviteSheet = () => {
    // const dispatch = useDispatch()

    const [invitationCode, setInvitationCode] = useState("");
    const [invitationCodeUsers, setInvitationCodeUsers] = useState([]);
    const dispatch = useDispatch();

    async function getProfile() {
        try {
            const res = await ProfileService.getProfile();
            if (res?.status === 200) {
                setInvitationCode(res.data?.data?.finduser?.code);
            }
        } catch (err) {
        }
    }

    //invitation  cde
    async function getUserOfInvitetionCode() {
        try {
            const res = await ProfileService.getAllInvitationCodeUesrs();
            setInvitationCodeUsers(res?.data?.data);
            console.log("inviteee:::", res?.data?.data);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getProfile();
        getUserOfInvitetionCode();
    }, []);

    // console.log("userrrr:::", profileInfo)

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    text: invitationCode,
                });
            } catch (err) {
            }
        } else {
        }
    };

    // convert to persian

    // function toPersianDateEnglishNumbers(isoDate) {
    //     const date = new Date(isoDate);
    //
    //     const parts = new Intl.DateTimeFormat("en-u-ca-persian", {
    //         year: "numeric",
    //         month: "2-digit",
    //         day: "2-digit",
    //     }).formatToParts(date);
    //
    //     const year = parts.find((p) => p.type === "year").value;
    //     const month = parts.find((p) => p.type === "month").value;
    //     const day = parts.find((p) => p.type === "day").value;
    //
    //     return `${year}/${month}/${day}`;
    // }

    // function formatPriceToToman(price) {
    //     const number = Number(price);
    //
    //     return number.toLocaleString("en-US");
    // }

    const [copied, setCopied] = React.useState(false);

    const handleCopy = (invitationCode) => {
        navigator.clipboard?.writeText(invitationCode);
        setCopied(true);
        dispatch(
            showToast({
                message: "Code copied.",
                type: "success",
            }),
        );
        setTimeout(() => setCopied(false), 2000);
    };


    const [allPrices, setAllPrices] = useState(0);

    useEffect(() => {
        setAllPrices(
            invitationCodeUsers.reduce((acc, it) => acc + (it?.price || 0), 0),
        );
    }, [invitationCodeUsers]);

    console.log("allPrices:::", allPrices);

    return (
        <>
            <div dir="ltr" className="bg-gray-50 pb-20">
                <header
                    className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4 border-b border-gray-100">
                    <div className="flex items-center justify-between">
                        <button
                            onClick={() => window.history.back()}
                            className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center hover:bg-gray-200 transition-all"
                        >
                            <FaArrowLeft className="text-gray-600"/>
                        </button>
                        <h1 className="text-xl font-bold text-gray-900">Referral Code</h1>
                        <div className="w-10"></div>
                    </div>
                </header>
                <div className="mt-20 bg-white pt-6 pb-8 px-5 relative border-b border-gray-100">
                    <div
                        className="bg-gradient-to-br from-primary to-indigo-500 rounded-3xl p-8 relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                        <div
                            className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>

                        <div className="relative z-10">
                            <div className="text-center mb-6">
                                <div
                                    className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                                    <FaGift className="text-white text-4xl"/>
                                </div>
                                <h2 className="text-2xl font-bold text-white mb-3">
                                    Invite Friends
                                </h2>
                                <p className="text-white/90 text-sm leading-relaxed">
                                    Invite your friends and both of you will receive a 50,000 USDT bonus.
                                </p>
                            </div>

                            <div className="bg-white rounded-2xl p-6 mb-5 shadow-xl">
                                <div className="text-center">
                                    <p className="text-xs text-gray-400 mb-3 uppercase tracking-widest font-medium">
                                        Your Refferal Code
                                    </p>
                                    <span
                                        id="invite-code"
                                        className="text-3xl font-mono font-bold text-primary tracking-wider"
                                    >
                    {invitationCode}
                  </span>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <button
                                    onClick={() => handleCopy(invitationCode)}
                                    className="bg-white text-primary py-4 rounded-xl font-semibold flex items-center justify-center gap-2 hover:shadow-lg transition-all shadow-md"
                                >
                                    {copied ? <FaCheck size={16}/> : <FaCopy size={16}/>}
                                    <span>Copy Code</span>
                                </button>
                                <button
                                    onClick={handleShare}
                                    className="bg-white/20 backdrop-blur-sm text-white py-4 rounded-xl font-semibold flex items-center justify-center gap-2 hover:bg-white/30 transition-all border-2 border-white/40"
                                >
                                    <FaShareNodes/>
                                    <span>Share</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="stats-section" className="px-5 -mt-6 relative z-0">
                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-center mb-3">
                                <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center">
                                    <FaUsers className="text-green-600 text-xl"/>
                                </div>
                            </div>
                            <div className="text-center">
                                <div className="text-3xl font-bold text-gray-900 mb-1">
                                    {invitationCodeUsers
                                        ? invitationCodeUsers.length.toLocaleString("en-US")
                                        : 0}
                                </div>
                                <div className="text-sm text-gray-500">Times Used</div>
                            </div>
                        </div>

                        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-center mb-3">
                                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center">
                                    <FaDollarSign className="text-blue-600 text-xl"/>
                                </div>
                            </div>
                            <div className="text-center">
                                <div className="text-3xl font-bold text-gray-900 mb-1">
                                    {allPrices.toLocaleString("en-US")}
                                </div>
                                <div className="text-sm text-gray-500">
                                    Total Reward (USDT)
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-2xl p-5 border border-yellow-200 mb-6">
                        <div className="flex items-start gap-3">
                            <div
                                className="min-w-10 min-h-10 bg-yellow-400 rounded-xl flex items-center justify-center flex-shrink-0">
                                <FaLightbulb className="text-white"/>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900 mb-1">
                                    How It Works
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Share your referral code with friends. When they sign up and
                                    complete their first trade, you'll both receive a 50,000 USDT
                                    reward!
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="history-section" className="px-5">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-bold text-gray-900">Usage History</h3>
                        <span className="text-sm text-gray-500">
              {invitationCodeUsers?.length || 0} invites
            </span>
                    </div>

                    <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-100">
                        {invitationCodeUsers.map((it) => (
                            <div
                                key={it?._id}
                                className="p-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="relative">
                                        <img
                                            src={defProfile}
                                            className="w-12 h-12 rounded-full object-cover"
                                            alt={''}
                                        />
                                        <div
                                            className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
                                            <FaCheck className="text-white text-xs"/>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="font-semibold text-gray-900 text-left">
                                            {it?.usedBy?.fullName}
                                        </div>
                                        <div className="text-sm text-gray-500 text-left">
                                            {it?.usedBy?.mobile}
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <div className="text-sm font-semibold text-green-600">
                                        {it?.price}{" "}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        {fixDate(it?.createdAt)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <div className="h-6"></div>
            </div>

            {/* <BottomSheet open={openInvite} onClose={() => setOpenInvite(false)} title="Invitation Code">
        <div className="space-y-6  h-full">
          <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-5 border border-indigo-200">
            <h4 className="font-bold text-gray-900 mb-3 ">Your Invitation Code</h4>
            <div className="bg-white rounded-xl p-4 mb-4">
              <div className="text-center">
                <span id="invite-code" className="text-2xl font-mono font-bold text-indigo-600">{invitationCode}</span>
              </div>
            </div>

            <div className="flex gap-2">
              <button onClick={() => handleCopy(invitationCode)}
                className="flex-1 bg-indigo-600 text-white py-3 rounded-xl font-medium flex items-center justify-center gap-2">
                {copied ? <FaCheck size={16} /> : <FaCopy size={16} />}
                <span>Copy Code</span>
              </button>
              <button onClick={handleShare} className="flex-1 bg-purple-600 text-white py-3 rounded-xl font-medium flex items-center justify-center gap-2">
                <FaShare size={16} />
                <span>Share Link</span>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-green-50 rounded-xl p-4 text-center border border-green-200">
              <div className="text-2xl font-bold text-green-600">{invitationCodeUsers?.length}</div>
              <div className="text-sm text-gray-600">Used</div>
            </div>
            <div className="bg-blue-50 rounded-xl p-4 text-center border border-blue-200">
              <div className="text-2xl font-bold text-blue-600">{formatPriceToToman(invitationCodeUsers.reduce((acc, item) => acc + item.price, 0))}</div>
              <div className="text-sm text-gray-600">Toman Reward</div>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200">
            <div className="p-4 border-b border-gray-100">
              <h4 className="font-bold text-gray-900">Usage History</h4>
            </div>
            <div className="divide-y divide-gray-100 h-[240px]  overflow-y-auto">
              {
                invitationCodeUsers?.map((it, index) => (
                  <div key={index} className="p-4 flex items-center justify-between">


                    <div className="flex items-center">
                      <img src={defProfile} className="w-10 h-10 rounded-full ml-3" />
                      <div>
                        <div className="font-medium text-gray-900">{(it?.usedBy?.userName) ? it?.usedBy?.userName : "unknown"}</div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-green-600">{formatPriceToToman(it.price)}+ Toman</div>
                      <div dir='ltr' className="text-xs text-gray-500">{toPersianDateEnglishNumbers(it.createdAt)}</div>
                    </div>
                  </div>
                ))
              }


              <div className="p-4 flex items-center justify-between">
                <div className="flex items-center">
                  <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg" className="w-10 h-10 rounded-full ml-3" />
                  <div>
                    <div className="font-medium text-gray-900">Maryam Ahmadi</div>
                    <div className="text-sm text-gray-500">@maryam_a</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-green-600">+50,000 Toman</div>
                  <div className="text-xs text-gray-500">1402/06/15</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BottomSheet> */}
        </>
    );
};

export default InviteSheet;
